import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Helpers from '../../../Helpers/Helpers'
import Notification from '../../../Helpers/Notification'
import { PostSchema } from '../../validation/PostSchema'

const AddPostComponent = () => {
    const helpers = Helpers()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [formData, setFormData] = useState({
        title: '',
        description: '',
        file: null
    })
    const [errors, setErrors] = useState({})

    const handleInputChange = (e) => {
        const { name, value } = e.target
        setFormData(prev => ({
            ...prev,
            [name]: value
        }))
        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }))
        }
    }

    const handleFileChange = (e) => {
        const file = e.target.files[0]
        setFormData(prev => ({
            ...prev,
            file: file
        }))
        // Clear file error
        if (errors.file) {
            setErrors(prev => ({
                ...prev,
                file: ''
            }))
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)

        try {
            // Validate form data
            await PostSchema.validate(formData, { abortEarly: false })
            setErrors({})

            // Create FormData for file upload
            const submitData = new FormData()
            submitData.append('title', formData.title)
            submitData.append('description', formData.description)
            if (formData.file) {
                submitData.append('file', formData.file)
            }

            const response = await helpers.httpRequest('/posts', 'POST', submitData, {
                'Content-Type': 'multipart/form-data'
            })

            if (response.status === 'success') {
                Notification('success', 'Post created successfully!')
                navigate('/blogs')
            } else {
                Notification('error', response.message || 'Failed to create post')
            }
        } catch (error) {
            if (error.name === 'ValidationError') {
                const validationErrors = {}
                error.inner.forEach(err => {
                    validationErrors[err.path] = err.message
                })
                setErrors(validationErrors)
            } else {
                console.error('Error creating post:', error)
                Notification('error', 'Error creating post')
            }
        } finally {
            setLoading(false)
        }
    }

    return (
        <section className="as_blog_wrapper as_padderBottom90 as_padderTop80">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-8 col-md-10 col-sm-12">
                        <div className="card">
                            <div className="card-header">
                                <h3 className="card-title">Add New Post</h3>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit} encType="multipart/form-data">
                                    <div className="form-group mb-3">
                                        <label htmlFor="title" className="form-label">Title</label>
                                        <input
                                            type="text"
                                            className={`form-control ${errors.title ? 'is-invalid' : ''}`}
                                            id="title"
                                            name="title"
                                            value={formData.title}
                                            onChange={handleInputChange}
                                            placeholder="Enter post title"
                                        />
                                        {errors.title && <div className="invalid-feedback">{errors.title}</div>}
                                    </div>

                                    <div className="form-group mb-3">
                                        <label htmlFor="description" className="form-label">Description</label>
                                        <textarea
                                            className={`form-control ${errors.description ? 'is-invalid' : ''}`}
                                            id="description"
                                            name="description"
                                            rows="5"
                                            value={formData.description}
                                            onChange={handleInputChange}
                                            placeholder="Enter post description"
                                        ></textarea>
                                        {errors.description && <div className="invalid-feedback">{errors.description}</div>}
                                    </div>

                                    <div className="form-group mb-3">
                                        <label htmlFor="file" className="form-label">Image</label>
                                        <input
                                            type="file"
                                            className={`form-control ${errors.file ? 'is-invalid' : ''}`}
                                            id="file"
                                            name="file"
                                            accept="image/*"
                                            onChange={handleFileChange}
                                        />
                                        {errors.file && <div className="invalid-feedback">{errors.file}</div>}
                                        <small className="text-muted">Supported formats: JPG, JPEG, PNG, WEBP (Max 5MB)</small>
                                    </div>

                                    <div className="form-group d-flex justify-content-between">
                                        <button
                                            type="button"
                                            className="btn btn-outline-secondary"
                                            onClick={() => navigate('/blogs')}
                                            disabled={loading}
                                        >
                                            <i className="fa fa-arrow-left me-2"></i>Back
                                        </button>
                                        <button
                                            type="submit"
                                            className="btn btn-success"
                                            disabled={loading}
                                        >
                                            {loading ? (
                                                <>
                                                    <i className="fa fa-spinner fa-spin me-2"></i>Creating...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="fa fa-save me-2"></i>Create Post
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AddPostComponent 